import React, { useState, useEffect } from "react";
import "../App.css";
import CommentForm from "./CommentForm.jsx";
import helpIcon from "../assets/delete.png";
import commentIcon from "../assets/comment.svg";
import likeIcon from "../assets/Heart.png";
import shareIcon from "../assets/share.png";
import { Link, useNavigate } from "react-router-dom";
import taco from "../assets/Taco.jpg";
import translations from "./translation.js";
import Modal from "./Modal.jsx";
/* This will render a single post, with all of the options like comments, delete, tags, etc. 
  
    This component takes in a post, a type, and a loadPosts props
    post: the current post to load/display
    type: - postlist if the post itself is the main post (doesn't have a parentId)
          - commentlist if the post is a comment on another post/comment (has a parentId)
    loadPosts: a function passed into the component which is used to load the posts/comments 
              depending on if it is a comment or an original post
*/

const Post = ({ post, type, loadPosts }) => {
  const [showModal, setShowModal] = useState(false);
  const [showShareModal, setShareModal] = useState(false);
  const [showTags, setShowTags] = useState(post.reactions.length > 0);
  const [comments, setComments] = useState(parseInt(post._count.children));

  const [isLoaded, setIsLoaded] = useState(false);
  const [postComments, setPostComments] = useState([]);

  const [postUserId, setPostUserId] = useState('')
  const [attributes, setAttributes] = useState({})

  useEffect(() => {
    getAuthorData(postUserId);
  }, [postUserId])

  useEffect(() => {
    updateEXP(attributes);
  }, [attributes])

  const updateEXP = (attributes) => {
    let currentEXP = 0;
    if (attributes.exp) {
      currentEXP = attributes.exp;
    }

    fetch(process.env.REACT_APP_API_PATH + "/users/" + postUserId, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify({
        attributes: {
          ...attributes,
          exp: currentEXP + 1
        }
      })
    })
    .then(result => result.json())
    .then(data => {
      setAttributes({})
      setPostUserId('')
    })
  }


  const getAuthorData = (userId) => {
    fetch(process.env.REACT_APP_API_PATH + "/users/" + userId, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      }
    })
      .then(result => result.json())
      .then(data => {
        if (data.attributes) {
          setAttributes(data.attributes)
        } else { setAttributes({}) }
      })
  }

  const getPostData = async (postID) => {
    await fetch(process.env.REACT_APP_API_PATH + "/posts/" + postID, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then(result => result.json())
      .then(data => {
        setPostUserId(data.authorID)
      })
  }

  const navigate = useNavigate();
  const currentLanguage = localStorage.getItem("selectedLanguage") || "en";
  const tagPost = (tag, thisPostID) => {
    //find the appropriate reaction to delete - namely, the one from the current user
    let userReaction = -1;
    post.reactions.forEach((reaction) => {
      if (reaction.reactorID === parseInt(sessionStorage.getItem("user"))) {
        userReaction = reaction.id;
      }
    });
    // if there is one, delete it.
    if (userReaction >= 0) {
      //make the api call to post
      fetch(
        process.env.REACT_APP_API_PATH + "/post-reactions/" + userReaction,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      ).then(
        (result) => {
          loadPosts();
        },
        (error) => {
          alert("error!" + error);
        }
      );
    } else {
      //make the api call to post
      fetch(process.env.REACT_APP_API_PATH + "/post-reactions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify({
          reactorID: sessionStorage.getItem("user"),
          postID: thisPostID,
          name: "like",
        }),
      }).then(
        (result) => {
          getPostData(thisPostID);
          loadPosts();
        },
        (error) => {
          alert("error!" + error);
        }
      );

    }
  };

  // function used to update the classname of the comments on a post
  // if the showModal state is true, show the comments, otherwise hide the comments
  const showHideComments = () => {
    return showModal ? "comments show" : "comments hide";
  };


  // function used to update the classname of the tags on a post
  const showHideTags = () => {
    if (showTags) {
      if (post.reactions.length > 0) {
        for (let i = 0; i < post.reactions.length; i++) {
          if (post.reactions[i].reactorID === sessionStorage.getItem("user")) {
            return "tags show tag-active";
          }
        }
      }
      return "tags show";
    }
    return "tags hide";
  };


  // Function used to delete a post given a postID in the parameter
  // if the post successfully is deleted, call lostPosts to reload the posts
  // to show all the posts without the deleted post
  const deletePost = (postID) => {
    fetch(process.env.REACT_APP_API_PATH + "/posts/" + postID, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((result) => {
        loadPosts();
      })
      .catch((error) => {
        alert("error!" + error);
      });
  };

  // function used to load the comments of a post given the post id from the props
  const loadComments = () => {
    if (sessionStorage.getItem("token")) {
      let url = process.env.REACT_APP_API_PATH + "/posts?parentID=" + post.id;

      fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((res) => res.json())
        .then((result) => {
          if (result) {
            setIsLoaded(true);
            setPostComments(result[0]);
            setComments(result[0].length);
          }
        })
        .catch((err) => {
          setIsLoaded(true);

          console.log("ERROR loading posts");
        });
    }
  };

  // load the comments of the specific post clicked on
  // loadComments will run when showModal get turned to true when the user clicks on the comment icon
  // useEffect(() => {
  //   loadComments();
  // }, [showModal]);

  useEffect(() => {
    if (!sessionStorage.getItem("token")) {
      navigate("/");
    }
  }, []);

  const showLike = () => {
    for (let i = 0; i < post.reactions.length; i++) {
      if (post.reactions[i].reactorID.toString() === sessionStorage.getItem("user")) {
        return (
          <img
            src={likeIcon}
            className="comment-icon liked"
            onClick={(e) => tagPost("like", post.id)}
            alt="Remove like"
          />
        );
      }
    }
    return (
      <img
        src={likeIcon}
        className="comment-icon"
        onClick={(e) => tagPost("like", post.id)}
        alt="Like post"
      />
    )
  };

  const handleShare = () => {
    setShareModal(!showShareModal);
    // this is from an on click event handler. if clicked, show a div, and close if clicked outside
  };

  const copyLink = (id) => {
    navigator.clipboard.writeText(window.location.host + "/viewpost/" + id);
  }

  const copySnippet = async (e, id) => {
    const text = document.getElementById(id).value;
    console.log("copy text:", text);
    const btn = e.target;

    try {
      await navigator.clipboard.writeText(text);
      btn.classList.add("copiedBtn");
      btn.textContent = "Copied!";
      setTimeout(() => {
        btn.classList.remove("copiedBtn");
        btn.textContent = "Copy Link";
      }, 1000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  }

  // Function to handle the display of comments and related functionality
  const commentDisplay = () => {

    let h = window.location.host;
    if (h.includes("webdev")) {
      h = h + "/hci/teams/ok";
    }

    return (
      <div className="comment-block">
        <div className="tagDiv">
          {showLike()}
        </div>
        {/* Display the number of likes for a given post */}
        <p>{post.reactions.length}</p>
        {/* Comment indicator and share icon */}
        <div className="comment-indicator">
          <img
            src={shareIcon}
            alt="share post"
            className="share-icon"
            title="Share Post"
            onClick={() => handleShare()}
          />
          {showShareModal && (
            <div className="share-pop">
              <h3>Share this post:</h3>
              <input type="text" id={"post-link-" + post.id} value={h + "/viewpost/" + post.id} readOnly />
              {/* <button onClick={copyLink(post.id)}>Copy Link</button> */}
              <button onClick={(e) => copySnippet(e, "post-link-" + post.id)}>Copy Link</button>
            </div>
          )}
          <Link to={`/viewpost/${post.id}`} >
            <div className="comment-indicator-text">{comments} {translations[currentLanguage].comments}</div>
          </Link>
        </div>
      </div>
    );
  };

  // Function to display the delete icon if the user is the author of post
  const showDelete = () => {
    if (post.authorID === parseInt(sessionStorage.getItem("user"))) {
      return (
        <img
          src={helpIcon}
          className="sidenav-icon deleteIcon"
          alt="Delete Post"
          title="Delete Post"
          onClick={() => deletePost(post.id)}
        />
      );
    }
    return null;
  };

  function getRandomColor() {
    return '#' + Math.floor(Math.random() * 16777215).toString(16);
  };

  const showTitle = () => {
    let title = "[No Title]";

    if (post.attributes && post.attributes.title) {
      title = post.attributes.title;
      if (title.length > 80) {
        title = title.substring(0, 80) + " ...";
      }
    }

    const titleStyle = {
      fontFamily: 'Bungee, FangSong, sans-serif',
      fontSize: "1.2rem",
      fontWeight: "400",
      width: "100%",
      wordWrap: "break-word"
    };

    return (
      <div className="post-title">
        <Link to={`/viewpost/${post.id}`}>
          <h2 style={titleStyle}>{title}</h2>
        </Link>
        {showDelete()}
      </div>
    );
  };

  const time = (date, options) => {
    if (currentLanguage === "en") {
      return new Intl.DateTimeFormat('en-US', options).format(date);
    }
    else {
      return new Intl.DateTimeFormat('zh-CN', options).format(date);
    }
  };
  const showCreated = (date) => {
    date = new Date(date);
    const options = {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    const formattedDateString = time(date, options);

    return (
      <span className="post-created">{translations[currentLanguage].created} {formattedDateString}</span>
    );
  };

  const translateCommunity = (community) => {
    switch (community) {
      case "FPS":
        return translations[currentLanguage].community1;
      case "Battle-Royale":
        return translations[currentLanguage].community2;
      case "MOBA":
        return translations[currentLanguage].community3;
      case "Sandbox":
        return translations[currentLanguage].community4;
      case "Action-Adventure":
        return translations[currentLanguage].community5;
      default:
        return community;
    }
  }
  const showCommunity = () => {
    if (post.attributes && post.attributes.CommunityID) {
      const community = translateCommunity(post.attributes.CommunityID);
      // console.log("COMMUNITY", community);
      return (
        <p style={{ textAlign: 'right' }}>
          <span style={{ color: 'white' }}>{translations[currentLanguage].in_community} </span>
          <Link to={`/games/${post.attributes.CommunityID.toLowerCase()}`}>
            {community}
          </Link>
        </p>
      );
    }
  };

  const showImg = () => {
    if (post.attributes && post.attributes.fileURL) {
      return (
        <img src={post.attributes.fileURL} className="post-img"></img>
      );
    }
  }
  const showcontent = () => {
    if (post.content) {
      let content = post.content;
      if (post.content.length > 100) {
        content = post.content.substring(0, 500) + " .........";
      }
      return (
        <p className="post-content" style={{ width: "100%", overflowWrap: "break-word" }}>
        {content}
        </p>
      );
    }
  }

  // Render the main post body with author information, delete icon (if applicable),
  // post content, and the comment display section including tags, reactions, and comments.
  return (
    <div key={post.id} className={[type, "postbody"].join(" ")} style={{ borderTop: `3px solid ${getRandomColor()}` }}>
      {showTitle()}
      <div className="deletePost">
        <Link to={`/user/${post.authorID}`}>
          <p>{post.author.attributes.username}</p>
        </Link> {showCommunity()}
      </div>
      {showcontent()}
      {showImg()}
      {commentDisplay()}
      {showCreated(post.created)}
    </div>
  );
};

export default Post;
